/**
 * Hero Configuration - Single Source of Truth
 * 
 * This file defines the first hero that must match:
 * 1. index.html preload link and static hero background
 * 2. heroCache.ts FIRST_HERO_FALLBACK
 * 3. HeroSection.tsx initial render
 * 
 * When updating the first hero in Supabase, update this config
 * to prevent flash-of-different-content on initial load.
 */

// The first hero image URL - MUST match index.html preload AND database media_url
export const FIRST_HERO_IMAGE_URL = 'https://hwjejrsktuenskryvsvl.supabase.co/storage/v1/object/public/applogos/Hero%20Landings/stranger_stuff_hero_2.avif';

// Complete first hero data for instant render
export const FIRST_HERO = {
  title: '',
  media_url: FIRST_HERO_IMAGE_URL,
  media_type: 'image' as const,
  subtitle: null as string | null,
  logged_out_subtitle: null as string | null,
  subscribed_subtitle: null as string | null,
  expired_subtitle: null as string | null,
  logged_out_title: null as string | null,
  subscribed_title: null as string | null,
  expired_title: null as string | null,
  book_id: null as number | null,
  tag: null as string | null,
  hide_logo: false,
  title_font: null as string | null
};

// Slide duration constants - increased for premium feel and preload time
export const SLIDE_DURATION_FIRST = 12000;  // 12 seconds for first slide
export const SLIDE_DURATION_DEFAULT = 10000; // 10 seconds for other slides
